import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=06a07393&scoped=true&"
import script from "./RoundButton.vue?vue&type=script&lang=js&"
export * from "./RoundButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=06a07393&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a07393",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a07393')) {
      api.createRecord('06a07393', component.options)
    } else {
      api.reload('06a07393', component.options)
    }
    module.hot.accept("./RoundButton.vue?vue&type=template&id=06a07393&scoped=true&", function () {
      api.rerender('06a07393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/RoundButton.vue"
export default component.exports